// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardBulkFollow-cls1_mhm","cls2":"BigCardBulkFollow-cls2_NvR BigCardBulkFollow-cls1_mhm"};